module.exports = __webpack_public_path__ + "img/antiSandBox_uncheck.6b8c067a.png";